import styles from './Header.module.scss';

const Header = () => {
  return (
    <header className={styles.header}>
      <div className={styles.b_logo}>
        <a href="/"></a>
      </div>

    </header>
  );
};

export default Header;
